import React from 'react';
import { useI18n } from './i18n';

// Says how official a sheet is: status 'formal' (reproduces a published form) or 'unofficial' (our own sheet).
// Props: status, source (who the form comes from / what inspired it, already translated), note (optional extra
// sentence, already translated), sourceNote (optional line on the primary source that was read and what was or was
// not verified, already translated). Shown on top of every sheet form of the Products tab.
function OfficialBadge({ status = 'unofficial', source, note, sourceNote }) {
  const { t } = useI18n();
  return (
    <div className={`official-badge ${status}`}>
      <span className="official-badge-label">{t(`products.badge.${status}`)}</span>
      {source && <span className="official-badge-source">{source}</span>}
      {note && <small className="official-badge-note">{note}</small>}
      {sourceNote && <small className="official-badge-sourcenote">{sourceNote}</small>}
    </div>
  );
}

export default OfficialBadge;
